<template>
  <input
    :id="id"
    :ref="'input' + id"
    type="text"
    class="input input-override"
    :class="classState"
    :value="renderValue" 
    @input="emitInputChanged"
    @click="focusIn('input'+id)" 
    @blur="emitFocusOut"
    @keyup.enter="emitFocusOut"
    autocomplete="off"
  />
</template>

<script>
export default {
  name: "BaseInputText",

  ////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////
  props: {
    id: [String, Number],
    dataValue : [Number, Boolean, String, Array],
    modelValue: [Number, String, Object],
    focusOutEnabled: {
      type: Boolean,
      default: true
    },
    suffix:{
      type: String,
      default:""
    },
    size: {
      type: String,
      default: "auto"
    },
    classState: String
  },
    ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  data() {
    return {
      displaySuffix: true,
    };
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  computed: {
    renderValue() {
      return ''.concat(this.modelValue, this.displaySuffix ? this.suffix: '')
    }
  },
  ////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////
  methods: {
    focusIn(){
      this.displaySuffix = false;
    },
    ///////////////////////////////////
    emitInputChanged: function(event) {
      if (this.focusOutEnabled)
        return;
      
      this.$emit('InputChanged', { id: this.id, value: event.target.value });
    },
    ////////////////////////////////////////////////////////////////
    emitFocusOut: function(event) {
      this.displaySuffix = true;

      if (!this.focusOutEnabled)
        return;

      this.$emit('InputChanged', { id: this.id, value: event.target.value });
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "@/lib/tui/scss/module/baseInput.scss";
</style>